// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepper-wrapper {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}
@media (max-width: 768px) {
  .stepper-item {
    font-size: 12px;
  }
}

.stepper-item::before {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 10px;
  left: -50%;
  z-index: 2;
}

.stepper-item::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 10px;
  left: 50%;
  z-index: 2;
}

.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
  color: #fff;
}

.stepper-item.active .step-counter {
  background-color: var(--ion-color-primary);
}

.stepper-item.completed .step-counter {
  background-color: var(--ion-color-primary);
}

.stepper-item.completed::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid var(--ion-color-primary);
  width: 100%;
  top: 10px;
  left: 50%;
  z-index: 3;
}

.stepper-item:first-child::before {
  content: none;
}

.stepper-item:last-child::after {
  content: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/step-progress-bar/step-progress-bar.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACJ;;AACE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,OAAA;AAEJ;AAAI;EAPF;IAQI,eAAA;EAGJ;AACF;;AAAE;EACE,kBAAA;EACA,WAAA;EACA,6BAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AAGJ;;AAAE;EACE,kBAAA;EACA,WAAA;EACA,6BAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AAGJ;;AAAE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAGJ;;AAAE;EACE,0CAAA;AAGJ;;AAAE;EACE,0CAAA;AAGJ;;AAAE;EACE,kBAAA;EACA,WAAA;EACA,iDAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AAGJ;;AAAE;EACE,aAAA;AAGJ;;AADE;EACE,aAAA;AAIJ","sourcesContent":[".stepper-wrapper {\r\n    margin-top: auto;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-bottom: 20px;\r\n  }\r\n  .stepper-item {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    flex: 1;\r\n  \r\n    @media (max-width: 768px) {\r\n      font-size: 12px;\r\n    }\r\n  }\r\n  \r\n  .stepper-item::before {\r\n    position: absolute;\r\n    content: \"\";\r\n    border-bottom: 2px solid #ccc;\r\n    width: 100%;\r\n    top: 10px;\r\n    left: -50%;\r\n    z-index: 2;\r\n  }\r\n  \r\n  .stepper-item::after {\r\n    position: absolute;\r\n    content: \"\";\r\n    border-bottom: 2px solid #ccc;\r\n    width: 100%;\r\n    top: 10px;\r\n    left: 50%;\r\n    z-index: 2;\r\n  }\r\n  \r\n  .stepper-item .step-counter {\r\n    position: relative;\r\n    z-index: 5;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 20px;\r\n    height: 20px;\r\n    border-radius: 50%;\r\n    background: #ccc;\r\n    margin-bottom: 6px;\r\n    color: #fff;\r\n  }\r\n  \r\n  .stepper-item.active .step-counter{\r\n    background-color: var(--ion-color-primary);\r\n  }\r\n\r\n  .stepper-item.completed .step-counter {\r\n    background-color: var(--ion-color-primary);\r\n  }\r\n  \r\n  .stepper-item.completed::after {\r\n    position: absolute;\r\n    content: \"\";\r\n    border-bottom: 2px solid var(--ion-color-primary);\r\n    width: 100%;\r\n    top: 10px;\r\n    left: 50%;\r\n    z-index: 3;\r\n  }\r\n  \r\n  .stepper-item:first-child::before {\r\n    content: none;\r\n  }\r\n  .stepper-item:last-child::after {\r\n    content: none;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
